let load = require('./helpers/browser/esm-js-loader');
module.exports = (load("fMsqj")).then(() => parcelRequire('hnnug'));